module.exports = __webpack_public_path__ + "img/ic_carteira_azul.482a79e1.svg";